interface Bar {
  label: string
  value: number
  color?: string
}

interface BarChartProps {
  bars: Bar[]
  height?: number
  formatValue?: (v: number) => string
  horizontal?: boolean
}

export default function BarChart({ bars, height = 120, formatValue, horizontal = false }: BarChartProps) {
  const max = Math.max(...bars.map(b => b.value), 1)

  if (horizontal) {
    return (
      <div className="flex flex-col gap-1.5 w-full">
        {bars.map((b, i) => (
          <div key={i} className="flex items-center gap-2 text-xs">
            <span className="text-ink-muted w-20 shrink-0 truncate text-right">{b.label}</span>
            <div className="flex-1 bg-sunken rounded-full h-4 overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{ width: `${(b.value / max) * 100}%`, backgroundColor: b.color ?? '#22d3ee' }}
              />
            </div>
            {formatValue && (
              <span className="text-ink-muted w-16 shrink-0">{formatValue(b.value)}</span>
            )}
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="flex items-end gap-1" style={{ height }}>
      {bars.map((b, i) => {
        const pct = (b.value / max) * 100
        return (
          <div key={i} className="flex flex-col items-center gap-1 flex-1 h-full justify-end">
            <div
              className="w-full rounded-t transition-all duration-500"
              style={{ height: `${pct}%`, backgroundColor: b.color ?? '#22d3ee', minHeight: pct > 0 ? 2 : 0 }}
            />
            <span className="text-[10px] text-ink-faint truncate max-w-full">{b.label}</span>
          </div>
        )
      })}
    </div>
  )
}
